import React, { useEffect, createElement } from 'react';
export function ChatbaseWidget() {
  useEffect(() => {
    // Initialize chatbase queue
    if (!(window as any).chatbase || (window as any).chatbase('getState') !== 'initialized') {
      ;
      (window as any).chatbase = (...args: any[]) => {
        if (!(window as any).chatbase.q) {
          ;
          (window as any).chatbase.q = [];
        }
        ;
        (window as any).chatbase.q.push(args);
      };
      (window as any).chatbase = new Proxy((window as any).chatbase, {
        get(target: any, prop: string) {
          if (prop === 'q') return target.q;
          return (...args: any[]) => target(prop, ...args);
        }
      });
    }
    // Load the embed script
    const script = document.createElement('script');
    script.src = 'https://www.chatbase.co/embed.min.js';
    script.id = 'r8qzO_bjYcijTG690sYtf';
    (script as any).domain = 'www.chatbase.co';
    document.body.appendChild(script);
    return () => {
      // Cleanup on unmount
      const existing = document.getElementById('r8qzO_bjYcijTG690sYtf');
      if (existing) existing.remove();
    };
  }, []);
  return null;
}